/**
 * SettlementType 结算类型
 * @type {string}
 */
const types = []
types.push({ 'chineseName': '全部', 'code': -1, englishName: 'All' })
types.push({ 'chineseName': '票结', 'code': 0, englishName: 'TicketSettlement' })
types.push({ 'chineseName': '月结', 'code': 1, englishName: 'SettlementTypeMonthly' })
export { types }
